import { StoreDevtoolsModule } from "@ngrx/store-devtools";

import { CommonModule, registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeNl from "@angular/common/locales/nl";
import { NgModule } from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";

import { NwdSharedModule } from "../nwd-shared/nwd-shared.module";
import { RssNewsRepository } from "./adapters/rss-news-repository.adapter";
import { NEWS_REPOSITORY } from "./domain/ports/news-repository.port";
import { routes } from "./news-routing.module";
import { NewsRoutingModule } from "./news-routing.module";
import { NewsHeaders } from "./ui/components/news-headers-list/news-headers-list.component";
import { NewsItemComponent } from "./ui/components/news-item/news-item.component";

registerLocaleData(localeNl, "nl");
registerLocaleData(localeEn, "en");

@NgModule({
  imports: [
    CommonModule,
    NewsHeaders,
    NewsItemComponent,
    NewsRoutingModule,
    NwdSharedModule,
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
  ],
  exports: [NewsHeaders],
  providers: [
    { provide: NEWS_REPOSITORY, useClass: RssNewsRepository },
    provideRouter(routes, withComponentInputBinding()),
  ],
})
export class NewsModule {}
